import React, { useState } from 'react';
import { tUi } from '../utils/uiText';

export default function PdfPasswordPrompt({
  uiLanguage = 'en',
  filename,
  passwordInvalid = false,
  queuePosition = null,
  onSubmit,
  onCancel,
  submitting = false,
}) {
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!password.trim() || submitting) return;
    onSubmit(password);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pdf-password-title"
    >
      <div className="w-full max-w-md rounded-lg border border-teal-500/30 bg-gray-900 p-6 shadow-2xl">
        <h3 id="pdf-password-title" className="text-lg font-semibold text-teal-400 mb-2">
          {tUi(uiLanguage, 'pdfPromptTitle')}
        </h3>
        <p className="text-sm text-gray-300 mb-1">
          <span className="font-medium text-white break-all">
            {tUi(uiLanguage, 'pdfPromptEncrypted', { filename })}
          </span>
        </p>
        <p className="text-sm text-gray-400 mb-4">
          {tUi(uiLanguage, 'pdfPromptBody')}
          {queuePosition && (
            <span className="block mt-1 text-teal-400/80">
              {tUi(uiLanguage, 'pdfPromptFileProgress', {
                current: queuePosition.current,
                total: queuePosition.total,
              })}
            </span>
          )}
        </p>
        {passwordInvalid && (
          <p className="text-sm text-red-300 mb-3 rounded border border-red-500/30 bg-red-950/30 px-3 py-2">
            {tUi(uiLanguage, 'pdfPromptInvalid')}
          </p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="pdf-document-password" className="block text-sm font-medium text-gray-300 mb-1">
              {tUi(uiLanguage, 'pdfPromptLabel')}
            </label>
            <input
              id="pdf-document-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="off"
              autoFocus
              disabled={submitting}
              className="w-full px-4 py-2.5 bg-black border border-teal-500/30 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              placeholder={tUi(uiLanguage, 'pdfPromptPlaceholder')}
            />
          </div>
          <div className="flex flex-wrap gap-2 justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="px-4 py-2 bg-gray-800 hover:bg-gray-700 disabled:opacity-50 text-gray-200 rounded-lg text-sm font-medium"
            >
              {tUi(uiLanguage, 'commonCancel')}
            </button>
            <button
              type="submit"
              disabled={submitting || !password.trim()}
              className="px-4 py-2 bg-teal-500 hover:bg-teal-400 disabled:bg-gray-700 disabled:text-gray-400 text-black font-semibold rounded-lg text-sm"
            >
              {submitting ? tUi(uiLanguage, 'pdfPromptUnlocking') : tUi(uiLanguage, 'pdfPromptUnlock')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
